import { render, staticRenderFns } from "./51.vue?vue&type=template&id=723a5344&scoped=true&"
var script = {}
import style0 from "./51.vue?vue&type=style&index=0&id=723a5344&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723a5344",
  null
  
)

export default component.exports